import { GameConfig } from "./GameConfig.js";
export const PlayerConfig = {
  FullHealth: {
    IMG_SRC: "./assets/player/player-full-health.png",
    HighHealth: 100,
    LowHealth: 75,
  },
  SlightDamage: {
    IMG_SRC: "./assets/player/player-slight-damage.png",
    HighHealth: 75,
    LowHealth: 50,
  },
  MidDamage: {
    IMG_SRC: "./assets/player/player-damaged.png",
    HighHealth: 50,
    LowHealth: 25,
  },
  HighDamage: {
    IMG_SRC: "./assets/player/player-very-damaged.png",
    HighHealth: 25,
    LowHealth: 0,
  },

  SPRITE_WIDTH: 100,
  SPRITE_HEIGHT: 64,

  INITIAL_HEALTH: 100,
  INITIAL_X_POS_PX: 80,
  INITIAL_Y_POS_PX: GameConfig.CANVAS_HEIGHT / 2,

  SPEED: 5,
  MAX_SPEED: 10,

  UP_DIRECTION: -1,
  DOWN_DIRECTION: 1,

  TOTAL_AMMO: 30,
};

export const PlayerPickupConfig = {
  SHIELD: {
    IMG_SRC: "./assets/player/shields/round-shield.png",
    MAX_FRAME: 11,
    SPRITE_WIDTH: 128,
    SPRITE_HEIGHT: 100,
    X_POS_BUFFER_PX: 24,
    Y_POS_BUFFER_PX: 20,
  },
  TURRET: {
    IMG_SRC: "./assets/player/pickups/SpaceGun.png",
    MAX_FRAME: 6,
    SPRITE_WIDTH: 100,
    SPRITE_HEIGHT: 64,
    X_POS_BUFFER_PX: -12,
    Y_POS_BUFFER_PX: 0,
  },
};

export const PlayerStates = {
  FLY: 0,
  ATTACK: 1,
  SHIELD: 2,
};

export const PlayerWeapons = {
  INITIAL_X_POS_PX:
    PlayerConfig.INITIAL_X_POS_PX + PlayerConfig.SPRITE_WIDTH / 2,
  CannonBullet: {
    IMG_SRC: "./assets/player/weapons/cannon-bullet.png",
    SPRITE_WIDTH: 32,
    SPRITE_HEIGHT: 32,
    DAMAGE: 2,
    SPEED: 10,
    MAX_FRAME: 3,
  },
};

export const PlayerBurstConfig = {
  SPRITE_WIDTH: 96,
  SPRITE_HEIGHT: 96,
  BASE: {
    IMG_SRC: "./assets/player/engine-bursts/base-engine-burst.png",
    BURST_SPEED: 5,
    MAX_FRAME: 2, // 0, 1, 2 (3 frames)
  },
};
